// @flow

import * as React from 'react'
import { List, Divider, Table } from 'semantic-ui-react'
import { type CardSummary } from '../store/campaigns'

const Item = List.Item

type Props = {|
  summary: CardSummary,
|}

const SummarySection = (props: Props) => {
  let center = { textAlign: 'center' }
  return (
    <div className="column">
      <Divider horizontal>Sommario</Divider>
      <Table basic="very" celled compact="very">
        <thead>
          <tr>
            <th>Canale</th>
            <th style={center}>Visite</th>
            <th style={center}>Rate</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Web</td>
            <td style={center}>{props.summary.WEB.visits}</td>
            <td style={center}>{props.summary.WEB.rate}</td>
          </tr>
          <tr>
            <td>F2F</td>
            <td style={center}>{props.summary.F2F.visits}</td>
            <td style={center}>{props.summary.F2F.rate}</td>
          </tr>
          <tr>
            <td>Phone</td>
            <td style={center}>{props.summary.PHONE.visits}</td>
            <td style={center}>{props.summary.PHONE.rate}</td>
          </tr>
          <tr>
            <td>
              <b>Totale</b>
            </td>
            <td style={center}>
              <b>{props.summary.total.visits}</b>
            </td>
            <td style={center}>
              <b>{props.summary.total.rate}</b>
            </td>
          </tr>
        </tbody>
      </Table>
      {props.summary.wave.num_waves > 0 && (
        <span>
          <div style={{ borderBottom: 'solid 1px #dedede', width: '100%', height: '1px', margin: '1ex 0' }} />
          <List>
            <Item>Wave presenti: {props.summary.wave.num_waves}</Item>
            <Item>Wave corrente: {props.summary.wave.last_wave}</Item>
            <Item>Visite wave corrente: {props.summary.wave.visits_last_wave}</Item>
          </List>
        </span>
      )}
    </div>
  )
}

export default SummarySection



// WEBPACK FOOTER //
// ./src/campaigns/summary-section.js